import { useTranslation } from "@outschool/localization";

export function useOnlineClassesPageTitle(): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return t("Affordable online classes for kids: academic, tutoring, and more");
}

export function useOnlineClassesPageDescription(): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return t(
    "Live online classes that make kids excited to learn. Try academic courses, virtual tutoring, fun clubs, and more. As low as $10 per class.",
  );
}
